import { Box, styled } from '@mui/material';
import Scrollbar from 'src/components/Scrollbar';
import SidebarMenu from './SidebarMenu';

const SidebarWrapper = styled(Box)(({ theme }) => ({
    width: theme.sidebar.width,
    minWidth: theme.sidebar.width,
    height: '100%',
    paddingBottom: 68,
}));

function Sidebar() {
    return (
        <SidebarWrapper>
            <Scrollbar>
                <Box sx={{ textAlign: 'center', mt: 2 }}>
                    <img src="/logotipo-aurosant-principal.svg" style={{ height: 50 }} alt="Logo" />
                </Box>
                <SidebarMenu />
            </Scrollbar>
        </SidebarWrapper>
    );
}

export default Sidebar;